import { config } from './config';

const _env = {
  production: false,
  envName: 'qa',
  baseUrl: 'https://api-v2-staging.eyrus.com',
  apexUrl: 'https://app-staging.eyrus.com/project/{projectId}/home',
  sentryDsn: 'https://0367d34d510044eb9292fdf0a137e120@sentry.io/1798683',
  firebase: {},
  // Google Analytics
  ga: {
    url: 'https://www.googletagmanager.com/gtag/js?id=UA-71851211-5',
    ua: 'UA-71851211-5'
  },
  stripe: {
    key: 'pk_test_Zrvkt1LgTmJnJIXO41DniARS'
  }
};

export const environment = { ..._env, ...config() };
